import { trackInternalEvent } from '@rio/tracking'
import { AIResumeDraftEvents } from 'builder/modules/constants'
import Tooltip from 'builder/components/Tooltip'
import { useI18n } from 'builder/hooks/useI18n'
import { useResumePrefill } from '../../hooks/useResumePrefill'
import { Props } from '../types'
import createWithAiImage from '../assets/create-with-ai.svg'
import starImg from '../assets/star.svg'
import {
  CreateWithAICard,
  CardTitleWrapper,
  CreateWithAICardTitle,
  ImageWrapper,
  Image,
  CreateWithAIArrowIcon,
  AIPoweredBadge,
  CardTitleContainer,
  AIStarImg,
  ArrowIcon,
} from './styles'

export const CreateWithAI = ({ onClose }: Props) => {
  const { i18n } = useI18n()

  const { handleCreateWithAi } = useResumePrefill()

  const handleCardClick = () => {
    trackInternalEvent(AIResumeDraftEvents.clickCreateWithAI)
    handleCreateWithAi()
    onClose()
  }

  return (
    <CreateWithAICard onClick={handleCardClick}>
      <ImageWrapper>
        <Image src={createWithAiImage} alt="Create with AI" />
      </ImageWrapper>
      <CardTitleWrapper>
        <CardTitleContainer>
          <CreateWithAICardTitle>
            {i18n.t('builder.ai_resume_draft.create_with_ai')}
          </CreateWithAICardTitle>
          <Tooltip value={i18n.t('builder.ai_resume_draft.ai_powered')}>
            <AIPoweredBadge>
              <AIStarImg src={starImg} alt="AI star" />
            </AIPoweredBadge>
          </Tooltip>
        </CardTitleContainer>
      </CardTitleWrapper>
      <CreateWithAIArrowIcon>
        <ArrowIcon />
      </CreateWithAIArrowIcon>
    </CreateWithAICard>
  )
}
